import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SystemHealthPage from '../SystemConfiguration/SystemHealthPage';
import ActivityLogsPage from './ActivityLogsPage';
import AuditTrailsPage from './AuditTrailsPage';
import ComplianceReportsPage from './ComplianceReportsPage';
import BackupsPage from './BackupsPage';
import ModuleUsagePage from './ModuleUsagePage';

const TAB_COMPONENTS = [SystemHealthPage, ActivityLogsPage, AuditTrailsPage, ModuleUsagePage, ComplianceReportsPage, BackupsPage];

export default function SecurityAuditPage() {
  const { t } = useTranslation();
  const [tab, setTab] = useState(0);
  const ActiveComponent = TAB_COMPONENTS[tab] || SystemHealthPage;

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab label={t('security.tabs.systemHealth', 'System Health')} />
        <Tab label={t('security.tabs.activityLogs', 'Activity Logs')} />
        <Tab label={t('security.tabs.auditTrails', 'Audit Trails')} />
        <Tab label={t('security.tabs.moduleUsage', 'Module Usage')} />
        <Tab label={t('security.tabs.compliance', 'Compliance')} />
        <Tab label={t('security.tabs.backups', 'Backups')} />
      </Tabs>
      <ActiveComponent />
    </Box>
  );
}
